"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTAuctionCancelBuilder = void 0;
const enums_1 = require("../enums");
const transactions_1 = require("../transactions");
const nft_exchange_builder_1 = require("./nft-exchange-builder");
class NFTAuctionCancelBuilder extends nft_exchange_builder_1.NFTExchangeTransactionBuilder {
    constructor() {
        super();
        this.data.type = enums_1.NFTTransactionTypes.NFTAuctionCancel;
        this.data.fee = transactions_1.NFTAuctionCancelTransaction.staticFee();
        this.data.asset = { nftAuctionCancel: {} };
    }
    NFTAuctionCancelAsset(nftAuctionCancel) {
        if (this.data.asset && this.data.asset.nftAuctionCancel) {
            this.data.asset.nftAuctionCancel = {
                ...nftAuctionCancel,
            };
        }
        return this;
    }
    instance() {
        return this;
    }
}
exports.NFTAuctionCancelBuilder = NFTAuctionCancelBuilder;
//# sourceMappingURL=nft-auction-cancel.js.map